/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is
 governed by the Apache 2.0 license. */

import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { t } from '../../../../../i18n';
import { usePathPrefix } from '../../../../../constants/hooks';

interface IProps {}

// eslint-disable-next-line no-empty-pattern
const RestocareLaunchScreen: FC<IProps> = ({}) => {
  const prefix = usePathPrefix();

  return (
    <div className={styles.wrap} id="launch">
      <div className={classNames(styles.image, styles.image_desktop)}>
        <img src={`${prefix}/case/restocare/launch_desktop.svg`} alt="launch" />
      </div>

      <div className={styles.content}>
        <h2>{t('cases.restocare.launch.title')}</h2>

        <div className={styles.terms}>
          <div className={styles.terms__term}>
            <img src={`${prefix}/case/restocare/check.svg`} alt="v" />
            <p>{t('cases.restocare.launch.term_1')}</p>
          </div>

          <div className={styles.terms__term}>
            <img src={`${prefix}/case/restocare/check.svg`} alt="v" />
            <p>{t('cases.restocare.launch.term_2')}</p>
          </div>

          <div className={styles.terms__term}>
            <img src={`${prefix}/case/restocare/check.svg`} alt="v" />
            <p>{t('cases.restocare.launch.term_3')}</p>
          </div>
        </div>
      </div>

      <div className={classNames(styles.image, styles.image_mobile)}>
        <img src={`${prefix}/case/restocare/launch_mobile.svg`} alt="launch" />
      </div>
    </div>
  );
};

export { RestocareLaunchScreen };
